/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Carve-outs are only ever written with incomplete, ready, submitted, approved, denied or cancelled. The other values are no longer used and will be removed once clients stop referencing them.
 * @export
 */
export const CarveOutStatus = {
    Incomplete: 'incomplete',
    Ready: 'ready',
    NeedsManualSubmission: 'needs_manual_submission',
    Pending: 'pending',
    Submitted: 'submitted',
    InfoNeeded: 'info_needed',
    Failed: 'failed',
    Approved: 'approved',
    Denied: 'denied',
    Cancelled: 'cancelled',
    Expired: 'expired',
} as const;
export type CarveOutStatus = typeof CarveOutStatus[keyof typeof CarveOutStatus];


export function instanceOfCarveOutStatus(value: any): boolean {
    for (const key in CarveOutStatus) {
        if (Object.prototype.hasOwnProperty.call(CarveOutStatus, key)) {
            if (CarveOutStatus[key as keyof typeof CarveOutStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CarveOutStatusFromJSON(json: any): CarveOutStatus {
    return CarveOutStatusFromJSONTyped(json, false);
}

export function CarveOutStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutStatus {
    return json as CarveOutStatus;
}

export function CarveOutStatusToJSON(value?: CarveOutStatus | null): any {
    return value as any;
}

export function CarveOutStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CarveOutStatus {
    return value as CarveOutStatus;
}

